export const IndustryEnum = {
  'Event tickets': 'event-tickets',
  'Digital products': 'digital-products',
  'Physical products': 'physical-products',
  Memberships: 'memberships',
  Subscriptions: 'subscriptions',
  'Software & SaaS': 'software-saas',
  Services: 'services',
  Donations: 'donations',
  Other: 'other',
};
